var _defs, _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

const SvgShowResults = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 24,
    viewBox: "0 0 140 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #Rectangle_1557.cls-1 {\n        fill: #4b4b4b;\n      }\n\n      #SHOW_RESULTS.cls-2 {\n        fill: #ececec;\n        font-size: 10px;\n        font-family: ArialMT, Arial;\n        letter-spacing: 0.2em;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_706",
    "data-name": "Group 706",
    transform: "translate(-905 -705)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1557",
    "data-name": "Rectangle 1557",
    className: "cls-1",
    width: 140,
    height: 24,
    rx: 12,
    transform: "translate(905 705)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Component_51_55",
    "data-name": "Component 51 \\u2013 55",
    transform: "translate(926.5 711.5)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "SHOW_RESULTS",
    "data-name": "SHOW RESULTS",
    className: "cls-2",
    transform: "translate(-2 9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SHOW RESULTS"))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShowResults, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ShowResults.4eac32fd.svg";
export { ForwardRef as ReactComponent };